import React ,{ lazy , Suspense } from 'react';
import { BrowserRouter as Router} from "react-router-dom";
import ReactLoading from 'react-loading';
import MainPage from "../components/mainPage/mainPage";
import './AuntContainer.css'
import App from "../App";



function AuntContainer() {
    return (
        <div className="AuntContainer ">
            <div className='wrapper'>
                <Suspense fallback={<ReactLoading type={"spokes"} className='loading' color={"black"} height={500} width={200} />}>
                    <Router path="/">
                        <App/>
                    </Router>
                </Suspense>
            </div>

        </div>
    )
}

export default AuntContainer;
